import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BookingStatus, TimingStatus } from 'src/app/services/api/api';
import { BookingStatusService } from 'src/app/services/booking-status/booking-status.service';

@Component({
  selector: 'sb-action-required',
  templateUrl: './sb-action-required.component.html',
  styleUrls: ['./sb-action-required.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SbActionRequiredComponent {
  private readonly translate = inject(TranslateService);
  private readonly bookingStatusService = inject(BookingStatusService);

  bookingStatus = input.required();

  hoverStatus = input<boolean>(true);
  messagesInline = input<boolean>(false);
  actionState = computed(() => {
    const bookingStatus = this.bookingStatus();
    const reasons: Map<BookingStatus, number> = this.bookingStatusService.getReasons(bookingStatus, [
      TimingStatus.Present,
      TimingStatus.Future,
    ]);
    const bookingStatusRequiringActions: BookingStatus[] = [
      BookingStatus.Rejected,
      BookingStatus.VerificationRevoked,
      BookingStatus.Proposed,
      BookingStatus.VerificationNotRequested,
    ];
    for (const bookingStatusTemp in BookingStatus) {
      if (!bookingStatusRequiringActions.includes(BookingStatus[bookingStatusTemp])) {
        reasons.delete(BookingStatus[bookingStatusTemp]);
      }
    }

    if (!bookingStatus) {
      const noBookingMessage: string = this.translate.instant('lang.actionRequired.reasons.noBookings');
      return { actionRequired: false, message: [noBookingMessage] };
    }
    if (reasons.size === 0) {
      const bookingCompleteMessage: string = this.translate.instant('lang.actionRequired.reasons.bookingComplete');
      return { actionRequired: false, message: [bookingCompleteMessage] };
    }
    const reasonStrs: string[] = [];
    for (const [bookingStatus, value] of reasons.entries()) {
      if (bookingStatus === BookingStatus.Rejected) {
        reasonStrs.push(this.translate.instant('lang.actionRequired.reasons.rejectedVerificationCount', { count: value }));
      }
      if (bookingStatus === BookingStatus.VerificationRevoked) {
        reasonStrs.push(this.translate.instant('lang.actionRequired.reasons.revokedVerificationCount', { count: value }));
      }
      if (bookingStatus === BookingStatus.Proposed) {
        reasonStrs.push(this.translate.instant('lang.actionRequired.reasons.motivesMissingCount', { count: value }));
      }
      if (bookingStatus === BookingStatus.VerificationNotRequested) {
        reasonStrs.push(this.translate.instant('lang.actionRequired.reasons.verificationRequestsMissingCount', { count: value }));
      }
    }
    return { actionRequired: true, message: reasonStrs };
  });
}
